import React from 'react';

export default ({
  classes,
  arrowRight,
  settingsIcon,
  mwRedirectEmail,
  autogeneratedMWEmail,
}) => {

  return (
    <div className={classes.descriptionFont}>
      <li><strong>For newest Outlook version:</strong></li>
      <li>1. Login to your Outlook mailbox.</li>
      <li className={classes.alignCenter}>2. At the top of the page, select &nbsp;<strong>Settings</strong>&nbsp;
        {settingsIcon}
        {arrowRight}
        <strong>View all Outlook settings</strong>.
      </li>
      <li className={classes.alignCenter}>3. Select&nbsp;<strong>Mail</strong>
      {arrowRight}
      &nbsp;<strong>Forwarding</strong>.
      </li>
      <li>4. Select&nbsp;<strong>Enable forwarding</strong> enter the &nbsp;{mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()}, and select<strong> Save</strong>.</li>

      <li className={`${classes.mt10} ${classes.mb10} ${classes.p10}`} style={{ backgroundColor: '#EEECF8' }}>
        <strong>Note:</strong><br></br>
        <span>- If you want a copy of the original message to remain in your mailbox, select <strong>Keep a copy of forwarded messages</strong>.</span><br></br>
        <span>- If the instructions don't match what you see, you might be using an older version of Outlook. Try the instruction you see below</span>
      </li>

      <li><strong>For older Outlook version:</strong></li>
      <li>1. Login to your Outlook mailbox.</li>
      <li className={classes.alignCenter}>2. At the top of the page, select &nbsp;<strong>Settings</strong>&nbsp;
        {settingsIcon}
        {arrowRight}
        <strong>Mail</strong>.
      </li>
      <li className={classes.alignCenter}>3. In the Options menu, select&nbsp;<strong>Mail</strong>
        {arrowRight}
        &nbsp;<strong>Accounts</strong>
        {arrowRight}
        &nbsp;<strong>Forwarding</strong>.
      </li>
      <li>4. To turn on forwarding, select&nbsp;<strong>Start forwarding </strong>enter the&nbsp;{mwRedirectEmail ? mwRedirectEmail : autogeneratedMWEmail()}, and select<strong> Save</strong>.</li>
    </div>
  );
};
